<template>
	<div class="flex user-tagging-list-item">
		<slot name="checkbox" />

		<div class="tagging-user-name font-capitalize text-truncate flex">
			<div :class="['tagging-user-name-wrapper', { admin: user.isAdmin }]">
				{{ user.attributes.fullName }}
			</div>
			<div v-show="user.isAdmin" class="team-admin-badge">
				<SVGIcon class="user-tag-admin-icon" icon-name="tagging-admin-icon" width="15" height="15" />
				{{ $tc('events.player.addons.userTagging.tagTeamAdminText') }}
			</div>
		</div>
	</div>
</template>

<script>
import SVGIcon from '~/components/interface/SVGIcon'

export default {
	name: 'UserTaggingListItem',
	components: {
		SVGIcon
	},
	props: {
		user: {
			type: Object,
			default: null
		}
	}
}
</script>
